// extracted by mini-css-extract-plugin
export default {"row":"Discounted_row__q1Q2S","title":"Discounted_title__hoQ+I","blue":"Discounted_blue__ZQDcC","vinyls":"Discounted_vinyls__bIZrJ"};